"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var syncNative_exports = {};
__export(syncNative_exports, {
  getNativeSyncFactory: () => getNativeSyncFactory
});
module.exports = __toCommonJS(syncNative_exports);
var import_syncInstaller = require("./syncInstaller");
var GLOBAL_KEY = "__OneNativeSyncState";
function getNativeSyncFactory() {
  var _ref;
  var _getSyncStateInstaller;
  var globals = globalThis;
  var existing = globals[GLOBAL_KEY];
  if (existing) return existing;
  var installed = (_ref = (_getSyncStateInstaller = (0, import_syncInstaller.getSyncStateInstaller)()) === null || _getSyncStateInstaller === void 0 ? void 0 : _getSyncStateInstaller.install()) !== null && _ref !== void 0 ? _ref : false;
  var factory = installed ? globals[GLOBAL_KEY] : void 0;
  if (!factory) {
    throw new Error("useNativeState requires the OneNative native module (iOS or Android): the sync handle is native-owned.");
  }
  return factory;
}
//# sourceMappingURL=syncNative.js.map
